import { gql } from '@apollo/client';

const CONTACT_CARD_FIELDS = `
  id
  path

  Image: field(name: "Image") {
    value
    jsonValue
  }

  Title: field(name: "Title") {
    value
  }

  Description: field(name: "Description") {
    value
  }

  ContactInformation: field(name: "ContactInformation") {
    value
  }

  ContactIcon: field(name: "ContactIcon") {
    value
    jsonValue
  }

  Phone: field(name: "Phone") {
    value
  }

  PhoneIcon: field(name: "PhoneIcon") {
    value
    jsonValue
  }

  Email: field(name: "Email") {
    value
  }

  EmailIcon: field(name: "EmailIcon") {
    value
    jsonValue
  }

  CTA: field(name: "CTA") {
    value
    jsonValue
  }

  CTAType: field(name: "CTAType") {
    value
    jsonValue
  }

  BackgroundColor: field(name: "BackgroundColor") {
    value
    jsonValue
  }

  ContactCardCategories: field(name: "ContactCardCategories") {
    value
    jsonValue
  }
`;

export const GET_CONTACT_CARDS = gql`
  query GetContactCards(
    $path: String!
    $templateId: String!
    $pageSize: Int!
    $after: String
  ) {
    search(
      first: $pageSize
      after: $after
      where: {
        AND: [
          { name: "_path", value: $path, operator: CONTAINS }
          { name: "_templates", value: $templateId, operator: CONTAINS }
        ]
      }
      orderBy: { name: "Title", direction: ASC }
    ) {
      total
      pageInfo {
        endCursor
        hasNext
      }
      results {
        ${CONTACT_CARD_FIELDS}
      }
    }
  }
`;

export const GET_CONTACT_CARDS_BY_CONTACT_CARD_CATEGORY = gql`
  query GetContactCardsByContactCardCategory(
    $path: String!
    $templateId: String!
    $contactCardCategoryId: String!
    $pageSize: Int!
    $after: String
  ) {
    search(
      first: $pageSize
      after: $after
      where: {
        AND: [
          { name: "_path", value: $path, operator: CONTAINS }
          { name: "_templates", value: $templateId, operator: CONTAINS }
          {
            name: "ContactCardCategories"
            value: $contactCardCategoryId
            operator: CONTAINS
          }
        ]
      }
      orderBy: { name: "Title", direction: ASC }
    ) {
      total
      pageInfo {
        endCursor
        hasNext
      }
      results {
        ${CONTACT_CARD_FIELDS}
      }
    }
  }
`;